import { createEffect } from 'effector';
import * as request from '../../../api/global';

export const getCategoryList = createEffect(() => request.getCategoryList());

export const getPromo = createEffect(() => request.getPromo());
